import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import "./QuoteRequestModal.scss";

export const QuoteRequestModal = ({ show, onHide, configUrl, estimatedCost }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isError, setIsError] = useState(false);
  const formInitializedRef = useRef(false);

  // Reset states when modal closes
  useEffect(() => {
    if (!show) {
      setIsSubmitted(false);
      setIsError(false);
      formInitializedRef.current = false;
      // Clear form container when modal closes
      const container = document.getElementById("hubspot-form-container");
      if (container) container.innerHTML = "";
    }
  }, [show]);

  useEffect(() => {
    if (show && window.hbspt && !formInitializedRef.current) {
      // Clear any existing form
      const container = document.getElementById("hubspot-form-container");
      if (container) container.innerHTML = "";

      // Mark form as initialized
      formInitializedRef.current = true;

      // Create HubSpot form
      window.hbspt.forms.create({
        portalId: "273433",
        formId: "26dc0d32-7454-43a8-b8e1-699c3f495ebd",
        region: "na1",
        target: "#hubspot-form-container",
        onFormReady: function ($form) {
          const configUrlField = $form.find('input[name="desk_configurator_results_url"]');
          const estimatedCostField = $form.find('input[name="desk_configurator_estimated_cost"]');
          if (configUrlField.length) {
            configUrlField.val(configUrl);
            configUrlField.trigger("change");
          }
          if (estimatedCostField.length) {
            estimatedCostField.val(estimatedCost);
            estimatedCostField.trigger("change");
          }
        },
        onFormSubmitted: function () {
          setIsSubmitted(true);
        },
        onFormError: function ($form) {
          console.error("Form submission failed");
          setIsError(true);
        },
      });
    }
  }, [show, configUrl, estimatedCost]);

  const handleClose = () => {
    setIsSubmitted(false);
    setIsError(false);
    formInitializedRef.current = false;
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="text-black">{isSubmitted ? "Quote Request Submitted" : "Request a Quote"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isError ? (
          <div className="error-message text-center py-4">
            <h3>Something went wrong</h3>
            <p>Please try again or contact us directly if error persists.</p>
            <button className="btn btn-secondary mt-3" onClick={handleClose}>
              Close
            </button>
          </div>
        ) : (
          <div id="hubspot-form-container"></div>
        )}
      </Modal.Body>
    </Modal>
  );
};
